import React from 'react';
import PropTypes from 'prop-types';

const Label = ({ text, classNames }) => {
  return (
    <div className={`common-label ${classNames}`}>
      {text}
    </div>
  );
}

Label.propTypes = {
  classNames: PropTypes.string,
  text: PropTypes.string.isRequired,
};

Label.defaultProps = {
  classNames: '',
};

export default Label;



// WEBPACK FOOTER //
// ./src/features/common/Label.js